import { ReactElement } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { SenecBaseTheme } from "src/styles/senecBaseTheme";
import { SenecTabList } from "src/components/navigation/tabs/SenecTabs";

export type SenecTimeIntervalDescriptor = {
    label: string;
    labelMobile?: string;
    value: string;
    dataTestId?: string;
};

export interface SenecTimeIntervalSelectionProps {
    /** An array from tab labels with values in the following format: label, labelMobile (optional, will be presented on mobile), value, dataTestId (optional) */
    timeIntervals: SenecTimeIntervalDescriptor[];
    /** Should be a value from the TimeIntervals Array  */
    selectedTimeInterval: string;
    /** Is called when time interval is changing */
    onChangeTimeInterval(value: string): void;
    dataTestId?: string;
}

export const SenecTimeIntervalSelection = (props: SenecTimeIntervalSelectionProps): ReactElement => {
    const theme: SenecBaseTheme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("tablet"));

    return (
        <SenecTabList
            data-testid={props.dataTestId}
            value={props.selectedTimeInterval}
            onChange={(event, value) => props.onChangeTimeInterval(value)}
            tabsConfig={props.timeIntervals.map((item) => ({
                label: isMobile && item.labelMobile ? item.labelMobile : item.label,
                value: item.value,
                "data-testid": item.dataTestId,
            }))}
            sx={{
                display: "grid",
                justifyContent: { xsMobile: "start", tablet: "center" },
                gridTemplateColumns: "repeat(6, max-content)",
                paddingY: 2,
                gap: 0,
                position: { xsMobile: "sticky", tablet: "static" },
                zIndex: 22,
                button: {
                    color: "neutralGray70.main",
                    "&.MuiButtonBase-root.MuiTab-root.Mui-selected": {
                        color: "nightDarkGrey.main",
                    },
                    "&.MuiButtonBase-root.MuiTab-root:hover": {
                        "&::after": {
                            content: '""',
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            width: "100%",
                            height: "2px",
                            background: "deepBlue.main",
                            borderRadius: 8,
                        },
                    },
                },
            }}
        />
    );
};
